<template>
    <div>
        <div class="category d-flex d-flex-row flex-nowrap">
            <div class="category-item verticalAlignMiddle"><h2>{{ questionnaire.name }}</h2></div>
            <div class="edit-item verticalAlignMiddle textAlignRight"><a href="" v-on:click.stop.prevent="active = !active"><i class="fa fa-pencil"></i></a></div>
        </div>
        <hr style="margin-bottom:2px;margin-top:5px;"/>
        <div v-if="active" class="category-content oldTableContainer oldContent width100">
            <form>
		    <div v-for="questionModel in questionListModel" v-if="questionModel.visible() && checkSocialMediaQuestionVisibility(questionModel, false)" :key="questionModel.question.id"
                    :class="[{ compact: !questionModel.extended, extended: questionModel.extended }, 'd-flex', 'd-flex-row', 'flex-wrap']">
                <div class="label-item verticalAlignTop black500"><span>{{ questionModel.question.questionText }}</span><a v-if="hasDescription(questionModel.question)" href="" 
                    v-on:click.stop.prevent="questionModel.extended= !questionModel.extended">&nbsp;<i class="fa fa-info-circle"></i></a>
                    <div v-if="questionModel.extended" v-html="questionModel.question.description"></div>
                </div>
                <div class="content-item verticalAlignTop lightGrey">
                    <div v-if="socialNetworks">
	                    <component :is="getComponentName(questionModel.question)"
	                        :item="getProfileItem(questionModel.question)" :question="questionModel.question" :socialnetworks="socialNetworks" v-on:updateValue="updateValue"></component>
                    </div>
                    <div v-else>
                        <component :is="getComponentName(questionModel.question)"
                            :item="getProfileItem(questionModel.question)" :question="questionModel.question" v-on:updateValue="updateValue"></component>
                    </div>
                </div>
                <profileItemVisibilityEditor :item="getProfileItem(questionModel.question)" :readOnly="!active"></profileItemVisibilityEditor>
	            <profileSocialMediaConnector :item="getProfileItem(questionModel.question)" :socialnetworks="socialNetworks" :profileitems="getSocialMediaUrlProfileItems()" v-if="questionModel.question.propertyInfo.key.value === 'basis.socialnetworks.aktivneu'" v-on:updateSocialNetworks="getSocialNetworks" v-on:updateSocialNetworkUrlItem="updateSocialNetworkUrlItem"></profileSocialMediaConnector>
		    </div>
            <hr/>
            <div class="textAlignRight buttonBlockContainerRight">
                <button type="button" v-on:click="cancel" class="btn btn-white teaserButton width100">Abbrechen</button>
                <button type="button" 
                    v-on:click="save"
                    :disabled="errors.any()"
                    :class="['btn', 'btn-white', 'teaserButton', 'width100']">
                        <span>Speichern</span>
                </button>
            </div>
            </form>
        </div>
        <div v-if="!active" class="category-content">
            <div v-if="socialNetworks" class="socialMedia">
                <div v-for="questionModel in questionListModel" v-if="questionModel.visible() && checkConnectedSocialMediaQuestionVisibility(questionModel)" :key="questionModel.question.id" 
                        :class="[{ compact: !questionModel.extended, extended: questionModel.extended }, 'd-flex', 'd-flex-row', 'flex-wrap']">
                    <div class="label-item verticalAlignTop black500"><span>{{ questionModel.question.questionText }}</span><a v-if="hasDescription(questionModel.question)" href="" 
                        v-on:click.stop.prevent="questionModel.extended= !questionModel.extended">&nbsp;<i class="fa fa-info-circle"></i></a>
                        <div v-if="questionModel.extended" v-html="questionModel.question.description"></div>
                    </div>
                    <div class="content-item verticalAlignTop lightGrey"><span v-html="getAnswerText(questionModel.question)"></span></div>
                    <profileItemVisibilityEditor :item="getProfileItem(questionModel.question)" :readOnly="!active"></profileItemVisibilityEditor>
                    <profileSocialMediaConnector :item="getProfileItem(questionModel.question)" :socialnetworks="socialNetworks" :profileitems="getSocialMediaUrlProfileItems()" v-if="questionModel.question.propertyInfo.key.value === 'basis.socialnetworks.aktivneu'" v-on:updateSocialNetworks="getSocialNetworks" v-on:updateSocialNetworkUrlItem="updateSocialNetworkUrlItem" :readonly="!active"></profileSocialMediaConnector>
                </div>
                <div v-for="questionModel in questionListModel" v-if="questionModel.visible() && checkSocialMediaQuestionVisibility(questionModel, true)" :key="questionModel.question.id" 
                        :class="[{ compact: !questionModel.extended, extended: questionModel.extended }, 'd-flex', 'd-flex-row', 'flex-wrap']">
                    <div class="label-item verticalAlignTop black500"><span>{{ questionModel.question.questionText }}</span><a v-if="hasDescription(questionModel.question)" href="" 
                        v-on:click.stop.prevent="questionModel.extended= !questionModel.extended">&nbsp;<i class="fa fa-info-circle"></i></a>
                        <div v-if="questionModel.extended" v-html="questionModel.question.description"></div>
                    </div>
                    <div class="content-item verticalAlignTop lightGrey"><span v-html="getAnswerText(questionModel.question)"></span></div>
                    <profileItemVisibilityEditor :item="getProfileItem(questionModel.question)" :readOnly="!active"></profileItemVisibilityEditor>
                </div>
            </div>
            <div v-else>
			    <div v-for="questionModel in questionListModel" v-if="questionModel.visible()" :key="questionModel.question.id" 
	                    :class="[{ compact: !questionModel.extended, extended: questionModel.extended }, 'd-flex', 'd-flex-row', 'flex-wrap']">
	                <div class="label-item verticalAlignTop black500"><span>{{ questionModel.question.questionText }}</span><a v-if="hasDescription(questionModel.question)" href="" 
	                    v-on:click.stop.prevent="questionModel.extended= !questionModel.extended">&nbsp;<i class="fa fa-info-circle"></i></a>
	                    <div v-if="questionModel.extended" v-html="questionModel.question.description"></div>
	                </div>
	                <div class="content-item verticalAlignTop lightGrey"><span v-html="getAnswerText(questionModel.question)"></span></div>
	                <profileItemVisibilityEditor :item="getProfileItem(questionModel.question)" :readOnly="!active"></profileItemVisibilityEditor>
			    </div>
			</div>
        </div>
    </div>
</template>
<script>
    import ProfileItemVisibilityEditor from './ProfileItemVisibilityEditor.vue';
    import ProfileUnsupportedEditor from './ProfileUnsupportedEditor.vue';
    import ProfileChoiceEditor from './ProfileChoiceEditor.vue';
    import ProfileMultichoiceEditor from './ProfileMultichoiceEditor.vue';
    import ProfileStringEditor from './ProfileStringEditor.vue';
    import ProfileEmailEditor from './ProfileEmailEditor.vue';
    import ProfileUsernameEditor from './ProfileUsernameEditor.vue';
    import ProfileBooleanEditor from './ProfileBooleanEditor.vue';
    import ProfileDateTimeEditor from './ProfileDateTimeEditor.vue';
    import ProfileAddressEditor from './ProfileAddressEditor.vue';
    import ProfileInfoEditor from './ProfileInfoEditor.vue';
    import SocialMediaEditor from './ProfileSocialMediaEditor.vue';
    import ProfileSocialMediaConnector from './ProfileSocialMediaConnector.vue';
    import Modernizr from 'modernizr';
    import { Validator } from 'vee-validate';
    import dictionary from '../js/validation.js';

	export default {
		name: 'profileSurveyEditor',
		props: {
            profileId: String,
			survey: Object,
			surveydata: Object
        },
         data: function() {
        	return {
                active: false,
                inSave: false,
                questionnaire: null,
                questionListModel: null,
                origSurveydata: this.clone(this.surveydata),
                newSurveydata: this.clone(this.surveydata),
                socialNetworks: null
        	}
        },
        created: function() {
            this.questionnaire = this.survey.questionnaire;
            this.questionListModel = this.createQuestionModel();
            this.$validator.localize('de', dictionary.de);
            if(this.survey.shortName.shortname.includes('socialnetwork')) {
            	this.getSocialNetworks();
            }
        },
        methods: {
            save: function() {
                if (this.inSave) {
                    return;
                }
                if (this.errors.any()) {
                    return;
                }
                this.inSave = true;
                var self = this;

                let answer = {
                    surveyName: this.survey.shortName,
                    answers: []
                };
                this.questionListModel
                    .forEach((questionModel) => answer.answers.push(this.getAnswer(questionModel)));

                jQuery.ajax ({
                    url: '/profile/' + self.profileId + '/survey',
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(answer),
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        self.inSave = false;
                        self.origSurveydata = data;
                        self.newSurveydata = self.clone(data);
                        self.active = false; 
                        self.$scrollTo(self.$el);
                        self.$bus.$emit('changedCompletion');
                    },
                    error: function() {
                        self.inSave = false;
                        alert("error");
                    }
                });
            },
            cancel: function() {
                this.active = false;
                this.newSurveydata = this.clone(this.origSurveydata);

                this.questionListModel.forEach((questionModel) => {
                    let propertyKey = questionModel.question.propertyInfo.key.value 
                    if (propertyKey == 'basis.profile.info') {
                        this.$bus.$emit('changedInfo', this.getAnswerText(questionModel.question));
                    }
                    if (propertyKey == 'system.registration.name') {
                        this.$bus.$emit('changedUsername', this.getAnswerText(questionModel.question));
                    }
                    if (propertyKey.indexOf('.url') > -1 && propertyKey.indexOf('.url') === propertyKey.length - 4) {
                        this.$bus.$emit('changedUrl', {
                            propertyKey: propertyKey,
                            url: this.getAnswerText(questionModel.question)
                        });
                    }
                });

                this.$scrollTo(this.$el);
            },
            clone: function(obj) {
                return JSON.parse(JSON.stringify(obj));
            },
            getVisibilityClass: function(question) {
                let key = this.getPropertyKey(question);
                let visibility = this.newSurveydata[key].visibility;
                return 'fa ' 
                    + (visibility.indexOf('PUBLIC') != -1 ? 'fa-globe' : 'fa-lock')
                    + (visibility.indexOf('DEACTIVATED') != -1 ? ' brightGrey' : '');
            },
            getAnswerText: function(question) {
                let propertyValue = this.getPropertyValue(question);
                if (propertyValue == null) {
                    return '';
                }
                let propertyType = this.getPropertyType(question);
                switch(typeof propertyType === 'string' ? propertyType : propertyType.kind) {
                    case 'ADDRESS':
                        return (propertyValue.firstName.value ? propertyValue.firstName.value + ' ' : '')
                            + (propertyValue.lastName.value ? propertyValue.lastName.value: '')
                            + '<br/>'
                            + (propertyValue.street.value ? propertyValue.street.value: '') 
                            + (propertyValue.number.value ? ' ' + propertyValue.number.value: '')
                            + '<br/>'
                            + (propertyValue.zip.value ? propertyValue.zip.value + ' ': '') 
                            + (propertyValue.city.value ? propertyValue.city.value: '')
                            + '<br/>'
                            + (propertyValue.country.value ? propertyValue.country.value: '') 
                    case 'BOOLEAN':
                        return propertyValue === 'TRUE' ? 'Ja' : 'Nein';
                    case 'MULTICHOICE':
                        return propertyValue.choices.join(', ');
                    case 'STRING':
                    case 'CHOICE':
                    case 'SCALE':
                    case 'NUMBER':
                    case 'DATETIME':
                    case 'ALIAS':
                    case 'DERIVED':
                    case 'EMAIL':
                    case 'COUNTRY':
                    case 'DOUBLE_OPTIN':
                    case 'MATRIX':
                    default:
                        if (question.propertyInfo.key.value === 'basis.profile.info') {
                            if (propertyValue.value != null) {
                                return propertyValue.value.replace(/(?:\r\n|\r|\n)/g, '<br />');
                            }
                        }
                         //if (question.propertyInfo.key.value.indexOf('.url') > -1 && question.propertyInfo.key.value.indexOf('.url') === question.propertyInfo.key.value.length - 4) {
                        //	if (propertyValue.value != null) {
                        //        if (propertyValue.value.length > 0 && !(propertyValue.value.indexOf('http') === 0)) {
                        //            return '<a href="https://' + propertyValue.value + '" target="_blank">https://' + propertyValue.value + '</a>';
                        //        }else {
                        //        	return '<a href="' + propertyValue.value + '" target="_blank">' + propertyValue.value + '</a>';
                        //        }
                        //    }
                        //}
                        if (question.propertyInfo.key.value )
                        return propertyValue.value; 
                }
            },
            updateValue: function(question) {
                this.questionListModel = this.questionListModel.slice(0);
                let propertyKey = question.propertyInfo.key.value
                if (propertyKey == 'basis.profile.info') {
                    this.$bus.$emit('changedInfo', this.getAnswerText(question));
                }
                if (propertyKey == 'system.registration.name') {
                    this.$bus.$emit('changedUsername', this.getAnswerText(question));
                }
                if (propertyKey.indexOf('.url') > -1 && propertyKey.indexOf('.url') === propertyKey.length - 4) {
                    this.$bus.$emit('changedUrl', {
                        propertyKey: propertyKey,
                        url: this.getAnswerText(question)
                    });
                }
            },
            getPropertyKey: function(question) {
                return question.propertyInfo.key.idValue;
            },
            getProfileItem: function(question) {
               let key = this.getPropertyKey(question);
               return this.newSurveydata[key];
            },
            getPropertyValue: function(question) {
                return this.getProfileItem(question).propertyValue;
            },
            getPropertyType: function(question) {
                return question.propertyInfo.type;
            },
            hasDescription: function(question) {
                return (question.description != null && question.description.length > 0); 
            },
            getAnswer: function(questionModel) {
                let question = questionModel.question;
                let profileItem = this.getProfileItem(question);
                let propertyValue = profileItem.propertyValue;
                let propertyVisibility = profileItem.visibility;
                let answer = {
                    questionId: question.id,
                    visible: questionModel.visible(),
                    visibility: propertyVisibility,
                    type: 'STRING',
                    value: null
                };
                if(this.survey.shortName.shortname.includes('socialnetwork')) {
                	answer.visible = answer.visible && this.checkSocialMediaQuestionVisibilityOnSave(questionModel);
                }
                let propertyType = this.getPropertyType(question);
                switch(typeof propertyType === 'string' ? propertyType : propertyType.kind) {
                    case 'ADDRESS':
                        answer.type = 'ADDRESS';
                        if (propertyValue != null) {
                            answer.value = {
                                firstname: propertyValue.firstName.value, 
                                lastname: propertyValue.lastName.value, 
                                street: propertyValue.street.value, 
                                number: propertyValue.number.value,
                                city: propertyValue.city.value,
                                zip: propertyValue.zip.value,
                                country: propertyValue.country.value
                            };
                        }
                        break;
                    case 'BOOLEAN':
                        answer.type = 'BOOLEAN';
                        if (propertyValue != null) {
                            answer.value = propertyValue === 'TRUE';
                        }
                        break;
                    case 'MULTICHOICE':
                        answer.type = 'LIST';
                        answer.value = propertyValue.choices;
                        break;
                    case 'STRING':
                    case 'CHOICE':
                    case 'SCALE':
                    case 'NUMBER':
                    case 'DATETIME':
                    case 'ALIAS':
                    case 'DERIVED':
                    case 'EMAIL':
                    case 'COUNTRY':
                    case 'DOUBLE_OPTIN':
                    case 'MATRIX':
                    default:
                        if (propertyValue != null) {
                            answer.value = propertyValue.value;
                        }
                }
                return answer;
            },
            getComponentName: function(question) {
                let propertyType = this.getPropertyType(question);
                let type = typeof propertyType === 'string' ? propertyType : propertyType.kind;
                switch(type) {
                    case 'SCALE':
                    case 'NUMBER':
                    case 'ALIAS':
                    case 'DERIVED':
                    case 'COUNTRY':
                    case 'DOUBLE_OPTIN':
                    case 'MATRIX':
                        return 'UNSUPPORTED';
                    case 'ADDRESS':
                        return 'CUSTOM_ADDRESS'; /*ADDRESS is reserved*/
                    case 'DATETIME':
                    case 'BOOLEAN':
                    case 'CHOICE':
                    case 'MULTICHOICE':
                    case 'STRING':
                    case 'EMAIL':
                    default:
                        if (question.propertyInfo.key.value === 'basis.profile.info') {
                            return 'INFO';
                        }
                        if (question.propertyInfo.key.value === 'system.registration.name') {
                            return 'USERNAME';
                        }
                        if (question.propertyInfo.key.value === 'basis.facebook.url' || question.propertyInfo.key.value === 'basis.twitter.url'
                        		|| question.propertyInfo.key.value === 'basis.instagram.url') {
                            return 'SOCIAL_MEDIA_URL';
                        }
                        return type; 
                }
            },
            createQuestionModel: function() {
                let questionListModel = new Array();
                let questionMapModel = {};
                let self = this;

                this.questionnaire.questionList.forEach(function(question) {
                    let questionModel = {
                        question: question,
                        extended: false,
                        val: function() {
                            return self.getAnswerText(question);
                        }
                    };
                    switch(typeof question.propertyInfo.type === 'string' ? question.propertyInfo.type : question.propertyInfo.type.kind) {
                        case 'MULTICHOICE':
                            questionModel.checked = function(value) {
                                return self.getPropertyValue(question).choices.indexOf(value) != -1; 
                            }
                            break;
                        case 'CHOICE':
                            questionModel.checked = function(value) {
                                return self.getPropertyValue(question).value === value; 
                            }
                            break;
                        default:
                    }
                    if (question.dependenceExpression) {
                        let visibleFunction = new Function('frage', 'return (' + question.dependenceExpression + ')');
                        questionModel.visible = function() {
                            let result = visibleFunction(questionMapModel);
                            return result;
                        }
                    } else {
                        questionModel.visible = function() {
                            return true;
                        }
                    }
                    questionListModel.push(questionModel);
                    questionMapModel[question.questionKey] = questionModel;
                });

                return questionListModel;
            },
            getSocialNetworksSuccess: function(data) {
            	this.socialNetworks = data;
            },
            getSocialNetworks: function() {
                let self = this;
            	jQuery.ajax ({
                    url: '/profile/' + self.profileId + '/socialNetworks',
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: this.getSocialNetworksSuccess,
                    error: function() {console.log("could not load social networks")}
                });
            },
            checkSocialMediaQuestionVisibility: function(question, readonly) {
            	var result = true;
            	if(readonly && question.question.propertyInfo.key.value === 'basis.socialnetworks.aktivneu') {
            		return false;
            	}
            	if(this.socialNetworks) {
           		   if(question.question.propertyInfo.key.value === 'basis.twitter.url' || question.question.propertyInfo.key.value === 'basis.twitter.follower'
           				   || question.question.propertyInfo.key.value === 'basis.twitter.freunde') {
                       this.socialNetworks.forEach(function(entry) {
                           if(entry.type == "TWITTER") {
                        	   result = false;
                               return;
                           }
                       });
           		   }else if(question.question.propertyInfo.key.value === 'basis.instagram.url' || question.question.propertyInfo.key.value === 'basis.instagram.follower'
           				   || question.question.propertyInfo.key.value === 'basis.instagram.freunde') {
                       this.socialNetworks.forEach(function(entry) {
                           if(entry.type == "INSTAGRAM") {
                        	   result = false;
                               return;
                           }
                       });
           		   }
            	}
           		return result;
            },
            checkSocialMediaQuestionVisibilityOnSave: function(question) {
                var result = true;
                if(this.socialNetworks) {
                   if(question.question.propertyInfo.key.value === 'basis.twitter.follower' || question.question.propertyInfo.key.value === 'basis.twitter.freunde') {
                       this.socialNetworks.forEach(function(entry) {
                           if(entry.type == "TWITTER") {
                               result = false;
                               return;
                           }
                       });
                   }else if(question.question.propertyInfo.key.value === 'basis.instagram.freunde' || question.question.propertyInfo.key.value === 'basis.instagram.follower') {
                       this.socialNetworks.forEach(function(entry) {
                           if(entry.type == "INSTAGRAM") {
                               result = false;
                               return;
                           }
                       });
                   }
                }
                return result;
            },
            checkConnectedSocialMediaQuestionVisibility: function(question) {
            	var result = false;
            	if(question.question.propertyInfo.key.value === 'basis.socialnetworks.aktivneu') {
            		return true;
            	}
                return result;
            },
            getSocialMediaUrlProfileItems: function() {
            	var profileItems = {};
            	profileItems.instagram = {};
                var urlKey = 'basis.instagram.url';
                profileItems.instagram.url = this.newSurveydata[urlKey];
                profileItems.facebook = {};
                urlKey = 'basis.facebook.url';
                profileItems.facebook.url = this.newSurveydata[urlKey];
                profileItems.twitter = {};
                urlKey = 'basis.twitter.url';
                profileItems.twitter.url = this.newSurveydata[urlKey];
                return profileItems;
            },
            updateSocialNetworkUrlItem: function(accounts) {
            	var self = this;
            	var urlKey = null;
            	accounts.forEach(function(element) {
	            	if(element.type === 'TWITTER') {
	            		urlKey = 'basis.twitter.url';
	            	}else if(element.type === 'FACEBOOK') {
	            		urlKey = 'basis.facebook.url';
	            	}else if(element.type === 'INSTAGRAM') {
	            		urlKey = 'basis.instagram.url';
	            	}
	            	if(urlKey != null) {
	            	    self.newSurveydata[urlKey].propertyValue.value = element.url;
	            	}
            	});
            }
        },
        components: { 
            ProfileItemVisibilityEditor, 
            ProfileSocialMediaConnector,
            UNSUPPORTED: ProfileUnsupportedEditor,
            CHOICE: ProfileChoiceEditor,
            MULTICHOICE: ProfileMultichoiceEditor,
            BOOLEAN: ProfileBooleanEditor,
            STRING: ProfileStringEditor,
            DATETIME: ProfileDateTimeEditor,
            CUSTOM_ADDRESS: ProfileAddressEditor,
            INFO: ProfileInfoEditor,
            EMAIL: ProfileEmailEditor,
            USERNAME: ProfileUsernameEditor,
            SOCIAL_MEDIA_URL: SocialMediaEditor
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileSurveyEditor.vue?0d35b4b3